export default function SortSmartContracts(smartContractsArr, category) {
  let arr = [];
  for (let i = 0; i < smartContractsArr.length; i++) {
    const contract = smartContractsArr[i];
    // console.log(i, contract.RelevantScore);
    if (contract.RelevantScore === category) {
      //   console.log(i, contract.RelevantScore);
      arr.push(contract);
    }
  }
  return arr;
}
